import { render, staticRenderFns } from "./EmailTable.vue?vue&type=template&id=715e8838&"
import script from "./EmailTable.vue?vue&type=script&lang=js&"
export * from "./EmailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports